export enum LanguageSelectPopupTestIds {
  CLOSE_ICON = 'language-select-popup-close-icon',
  LIST = 'language-select-popup-list',
  LIST_ITEM = 'language-select-popup-list-item',
  ROOT = 'language-select-popup-root',
  TITLE = 'language-select-popup-title',
}
